<template>

    <v-toolbar-items>
        <!--v-btn flat="flat" to="/import">
            {{translater
            .__("Import")}}
        </v-btn-->
        <v-btn flat="flat" to="/users">
            {{translater
            .__("Users", "users")}}
        </v-btn>
        <v-btn flat="flat" to="/routes">
            {{translater
            .__("Routes", "routes")}}
        </v-btn>
        <Languages></Languages>
        <v-btn to="/account" flat="flat" v-if="isLoggedIn">
            {{
            translater
            .__("Account", "users")
            }}
        </v-btn>
        <v-btn to="/logout" flat="flat" v-if="isLoggedIn">
            {{
            translater
            .__("Logout", "users")
            }}
        </v-btn>

    </v-toolbar-items>


</template>

<script>
    import Languages from './Languages'

    export default {
        name: 'Admin',
        components: {
            Languages
        },
        computed: {
            isLoggedIn: {
                get() {
                    return this.$store.getters['auth/isLoggedIn'];
                }
            },

            translater: {
                get()
                {
                    return this.$store.getters['translate/translater'];
                }
            }


        }


    }
</script>


